"use strict";

(function( namespace ) {
	var config = {};

	/**
	* Load global variables. Fallback to default values if not found.
	*/
	namespace.loadEnvVars = function() {
		config.timeout = window.LUMIERE_TIMEOUT || 15000;
		config.jsTimeout = window.LUMIERE_JS_TIMEOUT || 5000;
		config.playerClass = window.LUMIERE_PLAYER_CLASS || "hearstLumierePlayer";
		config.nitehawkUrl = window.LUMIERE_NITEHAWK_URL;
		config.imaSdkUrl = window.LUMIERE_IMA_SDK_URL || "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
		config.fallbackImaPath = "/lumiere/fallback/ima3.js";
		config.gaUrl = window.LUMIERE_GA_URL || "https://www.google-analytics.com/analytics.js";
		config.fallbackGaPath = "/lumiere/fallback/analytics.js";
		config.assetsUrl = window.LUMIERE_ASSETS_URL || "http://assets.htvapps.com";
		config.animeUrl = window.LUMIERE_ANIME_URL || "http://anime.htvtools.us";
		config.animePath = "/v1/prod/animated-gifs/";
		config.animeEnabled = window.LUMIERE_ANIME_ENABLED || false;
		config.youboraAccCode = window.LUMIERE_YOUBORA_ACC_CODE || "hearst";
		config.logLevel = window.LUMIERE_LOG_LEVEL || "all";
	};

	/**
	* Return LUMIERE_TIMEOUT.
	*/
	namespace.getTimeout = function() {
		return config.timeout;
	};

	/**
	* Return LUMIERE_JS_TIMEOUT.
	*/
	namespace.getJsTimeout = function() {
		return config.jsTimeout;
	};

	/**
	* Return LUMIERE_PLAYER_CLASS.
	*/
	namespace.getPlayerClass = function() {
		return config.playerClass;
	};

	/**
	* Return LUMIERE_NITEHAWK_URL.
	*/
	namespace.getNitehawkUrl = function() {
		return config.nitehawkUrl;
	};

	/**
	* Return LUMIERE_IMA_SDK_URL.
	*/
	namespace.getImaSdkUrl = function() {
		return config.imaSdkUrl;
	};

	/**
	* Return path to fallback IMA JS.
	*/
	namespace.getFallbackImaUrl = function() {
		return config.assetsUrl + config.fallbackImaPath;
	};

	/**
	* Return LUMIERE_YOUBORA_ACC_CODE.
	*/
	namespace.getYouboraAccCode = function() {
		return config.youboraAccCode;
	};

	/**
	* Return LUMIERE_GA_URL.
	*/
	namespace.getGaUrl = function() {
		return config.gaUrl;
	};

	/**
	* Return path to fallback Google Analytics JS.
	*/
	namespace.getFallbackGaUrl = function() {
		return config.assetsUrl + config.fallbackGaPath;
	};
		
	/**
	* Return LUMIERE_LOG_LEVEL.
	*/
	namespace.getLogLevel = function() {
		return config.logLevel;
	};

	/**
	* Return path to Anime GIF service.
	*/
	namespace.getAnimeUrl = function() {
		return config.animeUrl + config.animePath;
	};

	/**
	* Return Anime service status.
	*/
	namespace.isAnimeEnabled = function() {
		return config.animeEnabled;
	};
})( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 65
// module chunks = 0